<ng-container *ngIf="icon && iconFrame !== null && iconWidth !== null && block">
  <pl-icon-text
    [iconColor]="block.data.icon.color"
    [iconFrame]="iconFrame"
    [iconWidth]="iconWidth"
    [icon]="icon"
    [text]="block.data.text"
    [buttonLabel]="block.data.button?.label || ''"
    [buttonVariant]="buttonVariant"
    [buttonHref]="block.data.button?.href || ''"
    [buttonType]="block.data.type"
  />
</ng-container>
